var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-input',{attrs:{"rules":_vm.rules.url,"name":"url","label":"Url"},model:{value:(_vm.formValue.url),callback:function ($$v) {_vm.$set(_vm.formValue, "url", $$v)},expression:"formValue.url"}})}
var staticRenderFns = []

export { render, staticRenderFns }